import React from "react"
import { OutboundLink } from "gatsby-plugin-google-gtag"
import style from "./footer.module.scss"
import facebook_png from "./img/icons8-facebook-32.png"
import instagram_png from "./img/icons8-instagram-32.png"
import tiktok_png from "./img/icons8-tiktok-32.png"
import youtube_png from "./img/icons8-youtube-32.png"

function Footer() {
  const currentYear = new Date().getFullYear()
  return (
    <div className={style.footer}>
      <div className={style.footer__icon}>
        <OutboundLink href="https://www.facebook.com/AcuBoston/"  rel="noreferrer" target="_blank">
          <img src={facebook_png} alt="facebook" width="32px" height="32px"/>
        </OutboundLink>
        <OutboundLink className={style.footer__iconInstagram}  rel="noreferrer" href="https://www.instagram.com/acuboston/" target="_blank">
          <img src={instagram_png} alt="instagram" width="32px" height="32px"/>
        </OutboundLink>
        <OutboundLink className={style.footer__iconInstagram}  rel="noreferrer" href="https://www.youtube.com/channel/UCnnOjXUuq59wrVxnFrtmfEA" target="_blank">
          <img src={youtube_png} alt="instagram" width="32px" height="32px"/>
        </OutboundLink>
        <OutboundLink className={style.footer__iconInstagram}  rel="noreferrer" href="https://www.tiktok.com/@acuboston_" target="_blank">
          <img src={tiktok_png} alt="instagram" width="32px" height="32px"/>
        </OutboundLink>
      </div>
      <h3 className={style.footer__copyright}>© {currentYear} AcuBoston, Inc. All Rights Reserved.</h3>
    </div>
  )
}

export default Footer
